module.exports = __webpack_public_path__ + "static/media/gujranwala-dark.4cd39b47.svg";